(function () {
  'use strict';

  // Purchase controls win over compact launchers, never over an open conversation.
  if (window.__p4mMobilePurchaseGuardReady) return;
  window.__p4mMobilePurchaseGuardReady = true;

  var CONTROL_SELECTOR = 'variant-picker, variant-picker fieldset, variant-picker select, .product-form-buttons';
  var MARKER = 'data-p4m-purchase-guard-hidden';
  var CLEARANCE = 8;
  var owned = new Map();
  var shadowObservers = new Map();
  var resizeTargets = new Set();
  var frame = 0;
  var suspended = false;
  var retryTimer = 0;
  var pendingChat = null;
  var pendingChatAttempts = 0;
  var media = window.matchMedia('(max-width: 749px)');
  var resizeObserver = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;

  function schedule() {
    if (!suspended && !frame) frame = window.requestAnimationFrame(update);
  }

  function visibleRect(node) {
    var rect = node.getBoundingClientRect();
    if (!(rect.width > 0 && rect.height > 0)) return null;
    var style = window.getComputedStyle(node);
    if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse') return null;
    return rect;
  }

  function overlaps(a, b) {
    return a.left < b.right + CLEARANCE && a.right > b.left - CLEARANCE &&
      a.top < b.bottom + CLEARANCE && a.bottom > b.top - CLEARANCE;
  }

  function ownsFocus(node) {
    var root = node.getRootNode();
    var active = root.activeElement || document.activeElement;
    return active === node || (active && node.contains(active));
  }

  function suppress(node, hide) {
    var previous = owned.get(node);
    if (hide && !previous) {
      previous = {
        visibility: node.style.getPropertyValue('visibility'),
        visibilityPriority: node.style.getPropertyPriority('visibility'),
        pointerEvents: node.style.getPropertyValue('pointer-events'),
        pointerEventsPriority: node.style.getPropertyPriority('pointer-events'),
        inert: node.getAttribute('inert'),
        marker: node.getAttribute(MARKER)
      };
      owned.set(node, previous);
      node.style.setProperty('visibility', 'hidden', 'important');
      node.style.setProperty('pointer-events', 'none', 'important');
      node.setAttribute('inert', '');
      node.setAttribute(MARKER, 'true');
    } else if (!hide && previous) {
      // Do not overwrite a later app-owned change to either inline property.
      if (node.style.getPropertyValue('visibility') === 'hidden' && node.style.getPropertyPriority('visibility') === 'important') {
        if (previous.visibility) node.style.setProperty('visibility', previous.visibility, previous.visibilityPriority);
        else node.style.removeProperty('visibility');
      }
      if (node.style.getPropertyValue('pointer-events') === 'none' && node.style.getPropertyPriority('pointer-events') === 'important') {
        if (previous.pointerEvents) node.style.setProperty('pointer-events', previous.pointerEvents, previous.pointerEventsPriority);
        else node.style.removeProperty('pointer-events');
      }
      if (node.getAttribute('inert') === '') {
        if (previous.inert === null) node.removeAttribute('inert');
        else node.setAttribute('inert', previous.inert);
      }
      if (previous.marker === null) node.removeAttribute(MARKER);
      else node.setAttribute(MARKER, previous.marker);
      owned.delete(node);
    }
  }

  function observeSizes(targets) {
    if (!resizeObserver) return;
    resizeTargets.forEach(function (node) {
      if (!targets.has(node)) {
        resizeObserver.unobserve(node);
        resizeTargets.delete(node);
      }
    });
    targets.forEach(function (node) {
      if (!resizeTargets.has(node)) {
        resizeObserver.observe(node);
        resizeTargets.add(node);
      }
    });
  }

  function observeChatRoot(host) {
    shadowObservers.forEach(function (observer, oldHost) {
      if (!oldHost.isConnected || oldHost !== host) {
        observer.disconnect();
        shadowObservers.delete(oldHost);
      }
    });
    if (host && host.shadowRoot && !shadowObservers.has(host)) {
      var observer = new MutationObserver(schedule);
      observer.observe(host.shadowRoot, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-expanded', 'hidden', 'class']
      });
      shadowObservers.set(host, observer);
    }
  }

  function update() {
    frame = 0;
    var width = document.documentElement.clientWidth || window.innerWidth;
    var height = document.documentElement.clientHeight || window.innerHeight;
    var mobile = media.matches && width <= 749;
    var products = mobile ? document.querySelectorAll('.product-information') : [];
    var controls = [];
    var sizes = new Set();
    var activeWidgets = new Set();
    var viewport = { left: 0, top: 0, right: width, bottom: height };

    products.forEach(function (product) {
      product.querySelectorAll(CONTROL_SELECTOR).forEach(function (control) {
        sizes.add(control);
        var rect = visibleRect(control);
        if (rect && overlaps(rect, viewport)) controls.push(rect);
      });
    });

    var host = document.querySelector('shopify-chat');
    observeChatRoot(host);
    var activator = host && host.shadowRoot && host.shadowRoot.querySelector('button[part="activator"]');
    if (activator) {
      var launcher = activator.closest('.activator-nudge') || activator;
      activeWidgets.add(launcher);
      sizes.add(activator);
      // The shopify-chat host covers the viewport; only its activator is a launcher.
      var chatRect = activator.getBoundingClientRect();
      var expanded = host.hasAttribute('open') || activator.getAttribute('aria-expanded') === 'true';
      var chatCollision = mobile && controls.length > 0 && !expanded && !ownsFocus(host) && !ownsFocus(launcher) &&
        chatRect.width > 0 && chatRect.height > 0 && overlaps(chatRect, viewport) &&
        controls.some(function (rect) { return overlaps(rect, chatRect); });
      suppress(launcher, chatCollision);
    }

    var google = document.querySelector('#google-merchantwidget-iframe-wrapper');
    if (google) {
      activeWidgets.add(google);
      sizes.add(google);
      var googleRect = google.getBoundingClientRect();
      var compact = googleRect.width > 0 && googleRect.width <= 300 && googleRect.height > 0 && googleRect.height <= 160;
      var googleCollision = mobile && controls.length > 0 && compact && !ownsFocus(google) &&
        overlaps(googleRect, viewport) && controls.some(function (rect) { return overlaps(rect, googleRect); });
      suppress(google, googleCollision);
    }

    owned.forEach(function (_previous, node) {
      if (!activeWidgets.has(node)) suppress(node, false);
    });
    observeSizes(sizes);

    // A custom element can attach its shadow root without a document mutation.
    // Retry that one incomplete host briefly; later host insertion restarts discovery.
    if (mobile && products.length && host && !activator) {
      if (pendingChat !== host) {
        pendingChat = host;
        pendingChatAttempts = 0;
      }
      if (!retryTimer && pendingChatAttempts < 60) {
        pendingChatAttempts += 1;
        retryTimer = window.setTimeout(function () { retryTimer = 0; schedule(); }, 1000);
      }
    } else {
      pendingChat = null;
      pendingChatAttempts = 0;
      if (retryTimer) window.clearTimeout(retryTimer);
      retryTimer = 0;
    }
  }

  function suspend() {
    suspended = true;
    if (frame) window.cancelAnimationFrame(frame);
    if (retryTimer) window.clearTimeout(retryTimer);
    frame = 0;
    retryTimer = 0;
    pendingChat = null;
    pendingChatAttempts = 0;
    owned.forEach(function (_previous, node) { suppress(node, false); });
    documentObserver.disconnect();
    shadowObservers.forEach(function (observer) { observer.disconnect(); });
    shadowObservers.clear();
    if (resizeObserver) resizeObserver.disconnect();
    resizeTargets.clear();
  }

  function resume() {
    suspended = false;
    documentObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
    schedule();
  }

  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('pagehide', suspend);
  window.addEventListener('pageshow', resume);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('scroll', schedule, { passive: true });
    window.visualViewport.addEventListener('resize', schedule, { passive: true });
  }
  media.addEventListener && media.addEventListener('change', schedule);
  document.addEventListener('focusin', schedule);
  document.addEventListener('focusout', schedule);
  document.addEventListener('shopify:section:load', schedule);
  document.addEventListener('variant:update', schedule);
  document.addEventListener('load', schedule, true);
  var documentObserver = new MutationObserver(schedule);
  documentObserver.observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['open'] });
  if (window.customElements && window.customElements.whenDefined) {
    window.customElements.whenDefined('shopify-chat').then(schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  schedule();
})();
